import voiceIndex from '../data/fish-voice-index.json'
import type { Character } from '../data/cutscenes'

export const CUTSCENE_VOICE_ROOT = voiceIndex.root

export function cutsceneVoiceClipId(cutsceneId: string, beatIndex: number, speaker: Character): string {
  return `${cutsceneId}-${String(beatIndex + 1).padStart(2, '0')}-${speaker}`
}

export function cutsceneVoiceClipUrl(cutsceneId: string, beatIndex: number, speaker: Character): string {
  return `${CUTSCENE_VOICE_ROOT}/${cutsceneVoiceClipId(cutsceneId, beatIndex, speaker)}.mp3`
}

/** Asset identity includes the performed words and speaker, not just the beat number. */
export function verifiedCutsceneVoiceClipUrl(id: string, speaker: Character, text: string): string | undefined {
  const entry = (voiceIndex.clips as Record<string, { speaker: string; text: string; file: string }>)[id]
  if (!entry || entry.speaker !== speaker || entry.text !== text) return undefined
  return `${CUTSCENE_VOICE_ROOT}/${entry.file}`
}
